import { START_LOADING_LIST, STOP_LOADING_LIST } from './constants';

export const startLoadingList = () => ({ type: START_LOADING_LIST });
export const stopLoadingList = () => ({ type: STOP_LOADING_LIST });
